import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "saveBar", "saveButton"]

  connect() {
    this.originalData = this._snapshot()

    // Show "Saved ✓" briefly when Turbo successfully submits the form
    this.formTarget.addEventListener("turbo:submit-end", (e) => {
      if (e.detail.success) {
        this.saveButtonTarget.value = "Saved ✓"
        this.saveButtonTarget.style.opacity = "0.75"
      }
    })
  }

  changed() {
    const dirty = this._isDirty()
    this.saveBarTarget.style.display = dirty ? "block" : "none"
  }

  submitted() {
    // Optimistically hide the save bar on submit
    this.saveBarTarget.style.display = "none"
  }

  _snapshot() {
    const data = {}
    for (const [key, value] of new FormData(this.formTarget).entries()) {
      data[key] = value
    }
    return data
  }

  _isDirty() {
    for (const [key, value] of new FormData(this.formTarget).entries()) {
      if (key === "user[password]" || key === "user[password_confirmation]") {
        if (value !== "") return true
        continue
      }
      if (value !== (this.originalData[key] ?? "")) return true
    }
    return false
  }
}
